// removed by extract-text-webpack-plugin
module.exports = {"city-love":"JgERSaw0","cityLove":"JgERSaw0","heart":"_2HDRJ_zZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CityLove/CityLove.pcss
// module id = 734
// module chunks = 0